export const PLATFORM_ICON_OPTIONS = [
  { id: 'netflix', label: 'Netflix' },
  { id: 'disney', label: 'Disney+' },
  { id: 'starplus', label: 'Star+' },
  { id: 'max', label: 'Max' },
  { id: 'spotify', label: 'Spotify' },
  { id: 'prime', label: 'Prime Video' },
  { id: 'iptv', label: 'IPTV' },
  { id: 'youtube', label: 'YouTube' },
  { id: 'appletv', label: 'Apple TV+' },
  { id: 'paramount', label: 'Paramount+' },
  { id: 'crunchyroll', label: 'Crunchyroll' },
  { id: 'vix', label: 'ViX' },
  { id: 'plex', label: 'Plex' },
  { id: 'hulu', label: 'Hulu' },
  { id: 'other', label: 'Otra' },
];

function Glyph({ id }) {
  if (id === 'netflix') {
    return <svg viewBox="0 0 32 32"><path fill="#E50914" d="M8 5h6l10 22h-6L8 5Z"/><path fill="#B20710" d="M8 5h6v22H8z"/><path fill="#F6121D" d="M18 5h6v22h-6z"/></svg>;
  }
  if (id === 'spotify') {
    return <svg viewBox="0 0 32 32"><circle cx="16" cy="16" r="14" fill="#1ED760"/><path d="M9 12.4c5.2-1.5 11.1-.8 15.2 1.4M10.2 17c4.4-1.1 9.4-.5 12.9 1.2M11.4 21.2c3.5-.8 7.2-.4 10.2.9" fill="none" stroke="#07130d" strokeWidth="2.2" strokeLinecap="round"/></svg>;
  }
  if (id === 'youtube') {
    return <svg viewBox="0 0 32 32"><rect x="3" y="7" width="26" height="18" rx="6" fill="#FF0033"/><path d="m13 11.5 8 4.5-8 4.5v-9Z" fill="#fff"/></svg>;
  }
  if (id === 'iptv') {
    return <svg viewBox="0 0 32 32"><rect x="4" y="7" width="24" height="18" rx="5" fill="none" stroke="#40E0D0" strokeWidth="2.3"/><path d="m13 12 8 4-8 4v-8Z" fill="#40E0D0"/><path d="m11 3 5 4 5-4" fill="none" stroke="#40E0D0" strokeWidth="2" strokeLinecap="round"/></svg>;
  }
  if (id === 'plex') {
    return <svg viewBox="0 0 32 32"><path d="m10 5 7 11-7 11h6l7-11-7-11h-6Z" fill="#E5A00D"/></svg>;
  }
  if (id === 'starplus') {
    return <svg viewBox="0 0 32 32"><path d="m12.5 5 2.4 6.3 6.6.4-5.1 4.2 1.7 6.4-5.6-3.5-5.6 3.5 1.7-6.4-5.1-4.2 6.6-.4L12.5 5Z" fill="#B596FF"/><path d="M23 12v10m-5-5h10" stroke="#fff" strokeWidth="2.2" strokeLinecap="round"/></svg>;
  }
  if (id === 'paramount') {
    return <svg viewBox="0 0 32 32"><circle cx="16" cy="16" r="13" fill="none" stroke="#4D9FFF" strokeWidth="2"/><path d="m8 23 7-12 3.2 5 2-3 4 10H8Z" fill="#4D9FFF"/><path d="M9 8.5 11 10m3-4 1 2.2m5.4-1.5L19.5 9m4.8.4-2 1.3" stroke="#4D9FFF" strokeWidth="1.4" strokeLinecap="round"/></svg>;
  }
  if (id === 'crunchyroll') {
    return <svg viewBox="0 0 32 32"><path d="M27 18.2A11.5 11.5 0 1 1 18.4 5c-5.9.9-9.2 6.3-7 11.2 1.8 4 6.6 5.6 10.4 3.5-1.4 4.1-7.6 4.8-10.3.7 5.4 4.7 12.8 1.8 15.5-2.2Z" fill="#F47521"/><circle cx="20.8" cy="14" r="4" fill="#F47521"/></svg>;
  }
  if (id === 'other') {
    return <svg viewBox="0 0 32 32"><rect x="5" y="7" width="22" height="18" rx="5" fill="none" stroke="currentColor" strokeWidth="2"/><path d="m13 11 8 5-8 5V11Z" fill="currentColor"/></svg>;
  }

  const words = {
    disney: 'D+',
    max: 'max',
    prime: 'prime',
    appletv: 'tv+',
    vix: 'ViX',
    hulu: 'hulu',
  };
  return <span className="platform-word-glyph">{words[id] || '?'}</span>;
}

export default function PlatformVisual({ platform, size = 'md', className = '' }) {
  const usesIcon = platform?.visualMode === 'icon' && platform?.icon;
  if (!usesIcon) {
    return (
      <span
        className={`platform-visual is-${size} uses-color ${className}`}
        style={{ background: platform?.color || '#6f67f6' }}
        aria-hidden="true"
      />
    );
  }
  return (
    <span className={`platform-visual is-${size} uses-icon icon-${platform.icon} ${className}`} aria-hidden="true">
      <Glyph id={platform.icon} />
    </span>
  );
}
